"use strict";
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.ContentPage = void 0;
const classnames_1 = __importDefault(require("classnames"));
const react_1 = __importDefault(require("react"));
const ContentBlock_1 = require("../Front/Page/ContentBlock");
const MainImage_1 = require("../Front/Page/MainImage");
const ContentPage = (props) => {
    const { className, image, children } = props;
    const classNames = (0, classnames_1.default)('content-page', className !== null && className !== void 0 ? className : '');
    return (react_1.default.createElement("div", { className: classNames },
        image && (react_1.default.createElement(MainImage_1.FrontPageImage, { src: image })),
        react_1.default.createElement(ContentBlock_1.FrontPageContentBlock, null, children)));
};
exports.ContentPage = ContentPage;
//# sourceMappingURL=ContentPage.js.map